var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3C1.3455 0 0 1.3455 0 3V21C0 22.6545 1.3455 24 3 24H21C22.6545 24 24 22.6545 24 21V3C24 1.3455 22.6545 0 21 0Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4384 7.37671C18.9073 7.65448 18.1075 7.78284 17.8424 7.81982C17.8402 7.80701 17.838 7.79474 17.8358 7.78247C18.7372 7.22491 19.0132 6.17517 19.0132 6.17517C18.4549 6.49432 17.9629 6.67139 17.5923 6.76953C17.3839 6.82538 17.2138 6.85559 17.0915 6.87244C16.5297 6.29639 15.7453 5.93896 14.877 5.93896C13.1686 5.93896 11.7834 7.32379 11.7834 9.03271C11.7834 9.09424 11.7851 9.1554 11.7891 9.216C11.7974 9.36414 11.8162 9.5097 11.8453 9.65125C11.0184 9.63898 8.03363 9.38538 5.56024 6.51227C5.56024 6.51227 4.18292 8.91534 6.49847 10.5569C6.49847 10.5569 5.56024 10.5276 5.06219 10.1758C5.06219 10.1758 4.91571 12.4914 7.58264 13.2238C7.58264 13.2238 6.64496 13.4586 6.17566 13.2533C6.17566 13.2533 6.64478 15.2462 8.98944 15.3931C8.98944 15.3931 7.3078 16.9326 4.56177 16.7111C5.91235 17.5662 7.51361 18.0611 9.23041 18.0611C14.0576 18.0611 17.9709 14.1479 17.9709 9.32074C17.9709 9.2605 17.9704 9.20026 17.9691 9.14001C17.9704 9.10431 17.9709 9.06879 17.9709 9.03271C17.9709 9.00763 17.9704 8.98254 17.97 8.95746C18.8625 8.36273 19.4384 7.37671 19.4384 7.37671Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.96847,
    y1: 3.37435,
    x2: 14.0388,
    y2: 16.3619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B0ED"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.42a8d7e30c9eb64299cc94917445dd33.svg";
export { ForwardRef as ReactComponent };